import { IAjaxProvider } from 'jinqu'
import { LinqService, QueryOptions } from 'linquest'
import { OneToOneSessionCategoryDto, OneToOneSessionCategoryTranslatedDto } from './models'

export class OneToOneSessionCategoryApi extends LinqService {
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  listTranslated(options?: QueryOptions) {
    const url = `/OneToOneSessionCategory/ListTranslated`
    let query = this.createQuery<OneToOneSessionCategoryDto>(url)
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}
    query = query.withOptions(options)
    return query
  }

  getAsync(id?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionCategory/GetAsync`
    let query = this.createQuery<OneToOneSessionCategoryTranslatedDto>(url)
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)
    return query.firstAsync()
  }

  saveAsync(dto?: OneToOneSessionCategoryTranslatedDto, options?: QueryOptions) {
    const url = `/OneToOneSessionCategory/SaveAsync`
    let query = this.createQuery<any>(url)
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}
    options.data = dto
    query = query.withOptions(options)
    return query.firstAsync()
  }

  deleteAsync(id?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionCategory/DeleteAsync`
    let query = this.createQuery<any>(url)
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)
    return query.firstAsync()
  }
}